
import React, { useState } from 'react';
import { Box, Menu, MenuItem, Typography } from '@mui/material';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import active from '../assets/Dashboard/active.svg';
import inactive from '../assets/Dashboard/inactive.svg';
import trial from '../assets/Dashboard/trial.svg';
import invited from '../assets/Dashboard/invited.svg';
import request from '../assets/Dashboard/request.svg';
import process from "../assets/Dashboard/process.svg";
import overdue from "../assets/Dashboard/overdue.svg";
import close from "../assets/Dashboard/close.svg";
import open1 from "../assets/Dashboard/open1.svg";
import reopen from "../assets/Dashboard/reopen.svg";
import received from "../assets/Wallet/received.svg";
import pending from "../assets/Wallet/pending.svg";
import { useTranslation } from "react-i18next";
import badge from "../assets/Dashboard/badge.svg";
import leave from "../assets/leave.svg";
const StatusDropdown = ({ currentStatus, onChange,statusOptions = [], showArrow = false,  }) => {

  const statusIcons = {
    free:active,
  Active: active,
  completed:active,
    active_paid: active,
 resolved: active,
    active: active,
  Trial: overdue,
  trial:overdue,
  Invited: invited,
 new: invited,
    invited: invited,
  Inactive: inactive,
  escalated:inactive,
   inactive: inactive,
  Requested: request,
    requested: request,
  Overdue: overdue,
  Processing: process,
  initiated:process,
  Paid: active,
  APPROVED:active,
   REJECTED:inactive,
  paid: active,
  Pending: pending,
  PENDING: pending,
    pending: pending,

   email_pending: pending,
  Received: active,
    received: active,
   Verified:active,
   verified:active,
   Blocked:inactive,
   expired:inactive,
   revoked:inactive,
   blocked:inactive,
   rejected:inactive,
   success:active,
      in_progress:overdue,
      payment_overdue:overdue,
       pending_threshold:overdue,
   failed:inactive,
   unclaimed:trial,
    returned:active,
    low:badge,
    medium:badge,
    high:badge,
    urgent:badge,
    critical:badge,
     closed:close,
      open:open1,
       reopened:reopen,
        assigned: leave,
ready_for_payout:request,
};
const statusStyles = {
  Active: { backgroundColor: '#4BCE97', color: '#164B35' },
    APPROVED: { backgroundColor: '#4BCE97', color: '#164B35' },
 REJECTED: { backgroundColor: '#D32F2F', color: '#FFFFFF' },

    completed: { backgroundColor: '#4BCE97', color: '#164B35' },
      active_paid: { backgroundColor: '#4BCE97', color: '#164B35' },
  resolved: { backgroundColor: '#4BCE97', color: '#164B35' },
    active: { backgroundColor: '#4BCE97', color: '#164B35' },
     success: { backgroundColor: '#4BCE97', color: '#164B35' },
  Trial: { backgroundColor: '#FEA362', color: '#702E00' },
   high: { backgroundColor: '#FEA362', color: '#702E00' },
   in_progress: { backgroundColor: '#FEA362', color: '#702E00' },
  reopened: { backgroundColor: '#57D5FF', color: '#095C6C' },
   closed: { backgroundColor: '#C1F2A0', color: '#215922' },
  low: { backgroundColor: '#BCBFC2', color: '#44546F' },
  Invited: { backgroundColor: '#579DFF', color: '#09326C' },
  new: { backgroundColor: '#579DFF', color:  '#09326C' },
  medium: { backgroundColor: '#579DFF', color: '#09326C' },
    Invited: { backgroundColor: '#579DFF', color: '#09326C' },
        invited: { backgroundColor: '#579DFF', color: '#09326C' },
  Inactive: { backgroundColor: '#F87168', color: '#5D1F1A' },
  escalated: { backgroundColor: '#F87168', color: '#5D1F1A' },
   critical: { backgroundColor: '#F87168', color: '#5D1F1A' },
      urgent: { backgroundColor: '#F87168', color: '#5D1F1A' },
      revoked: { backgroundColor: '#F87168', color: '#5D1F1A' },
  assigned: { backgroundColor: '#579DFF', color: '#09326C' },

    inactive: { backgroundColor: '#F87168', color: '#5D1F1A' },
  Requested: { backgroundColor: '#F5CD47', color: '#533F04' },
 open: { backgroundColor: '#F5CD47', color: '#533F04' },
    requested: { backgroundColor: '#F5CD47', color: '#533F04' },
  Paid: { backgroundColor: '#4CD08B', color: '#0E563F' },
    paid: { backgroundColor: '#4CD08B', color: '#0E563F' },
  Processing: { backgroundColor: '#FDD35C', color: '#7A4100' },
  Overdue: { backgroundColor: '#FFA26B', color: '#722800' },
  pending_threshold:{backgroundColor: '#FFA26B', color: '#722800'},
   payment_overdue: { backgroundColor: '#FFA26B', color: '#722800' },

  Pending: { backgroundColor: '#F5CD47', color: '#533F04' },
   PENDING: { backgroundColor: '#F5CD47', color: '#533F04' },

    email_pending: { backgroundColor: '#F5CD47', color: '#533F04' },

    pending: { backgroundColor: '#F5CD47', color: '#533F04' },
  Received: { backgroundColor: '#4BCE97', color: '#164B35' },
    received: { backgroundColor: '#4BCE97', color: '#164B35' },
 Verified: { backgroundColor: '#2196F3', color: '#0D47A1'  },
  verified: { backgroundColor: '#2196F3', color: '#0D47A1'  },
   Blocked: { backgroundColor: '#F87168', color: '#5D1F1A' },
 blocked: { backgroundColor: '#F87168', color: '#5D1F1A' },
expired: { backgroundColor: '#F87168', color: '#5D1F1A' },
  rejected: { backgroundColor: '#D32F2F', color: '#FFFFFF' },
  initiated: { backgroundColor: '#FDD35C', color: '#7A4100' },
  success: { backgroundColor: '#4CD08B', color: '#0E563F' },
   failed: { backgroundColor: '#F87168', color: '#5D1F1A' },
    trial: { backgroundColor: '#FEA362', color: '#702E00' },
unclaimed: { backgroundColor: '#FEA362', color: '#702E00' },
returned: { backgroundColor: '#4BCE97', color: '#164B35'  },
free: { backgroundColor: '#4BCE97', color: '#164B35'  },
ready_for_payout: {backgroundColor: '#F5CD47', color: '#533F04'   },
};
const canOpenDropdown = Object.keys(statusStyles).filter(
  status => status !== 'Paid' && status !== 'Received'
);
    const { t } = useTranslation();
const showDropdownIcon = ['Invited', 'Requested', 'Processing', 'Overdue','Verified','invited'];
const allStatuses = Object.keys(statusStyles);

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    if (canOpenDropdown.includes(currentStatus)) {
      setAnchorEl(event.currentTarget);
    }
  };
  const handleClose = (status) => {
    if (status) onChange(status);
    setAnchorEl(null);
  };
  const displayStatusLabels = {
    initiated: 'Processing',
    success: 'Paid',
    failed: 'Failed',
    // Add other overrides if needed
  };

  // Helper to get localized label for a status
  const getLocalizedStatus = (status) => {
    const key = displayStatusLabels[status] || status;
    return t(`statuses.${key}`) || key;
  };
  return (
    <>
      <Box
        onClick={handleClick}
        sx={{
          // display: 'flex',
          // alignItems: 'center',
          // gap: 0.5,
          // px: 0.4,
          // py: 0.4,
          // pr:0.5,
          // borderRadius: '4px',
          // fontWeight: 400,
          // fontFamily: 'Poppins, sans-serif',
          // fontSize: '13px',
          // cursor: canOpenDropdown.includes(currentStatus) ? 'pointer' : 'default',
          // width: 'fit-content',
          // cursor:"pointer",
          // ...statusStyles[currentStatus]
            display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: 0.5,
    px: 2,
    py: 0.4,
    borderRadius: "6px",
    fontWeight: 500,
    fontFamily: "Poppins, sans-serif",
    fontSize: "13px",
    cursor: canOpenDropdown.includes(currentStatus) ? "pointer" : "default",

    // 🌍 Responsive equal width logic
    flex: 1,                            // take full space inside table cell
    maxWidth: 120,                      // prevent overflow
    minWidth: 110,                      // ensure equal base size
    width: "100%",                      // allow auto-fit
    textAlign: "center",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    ...statusStyles[currentStatus]
        }}
      >
 
        <img src={statusIcons[currentStatus]} alt={currentStatus} style={{ width: 16, height: 16 }} />
      
        <Typography sx={{ fontSize: '13px', color: (statusStyles[currentStatus]?.color || '#333333') }}>
          {getLocalizedStatus(currentStatus)}
        </Typography>
      {showArrow && (
  <ArrowDropDownIcon 
    sx={{ 
      fontSize: 18, 
      color: statusStyles[currentStatus]?.color 
    }} 
  />
)}
      </Box>

      {/* <Menu anchorEl={anchorEl} open={open} onClose={() => handleClose(null)} sx={{ maxWidth: 140,                      // prevent overflow
    minWidth: 130,                      // ensure equal base size
    width: "100%", }}>
       
        {statusOptions.map((status) => (
  <MenuItem key={status} onClick={() => handleClose(status)}>
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      <img src={statusIcons[status]} alt={status} style={{ width: 16, height: 16 }} />
      <Typography sx={{ fontFamily: 'Poppins, sans-serif', fontSize: '13px' }}>{status}</Typography>
    </Box>
  </MenuItem>
))}
      </Menu> */}
      <Menu 
  anchorEl={anchorEl} 
  open={open} 
  onClose={() => handleClose(null)}
  PaperProps={{
    sx: {
      minWidth: 110,   // make menu more compact
      px: 0.5          // reduce overall padding
    }
  }}
>
  {statusOptions.map((status) => (
    <MenuItem 
      key={status} 
      onClick={() => handleClose(status)}
      sx={{ py: 0.7, px: 1 }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.6 }}>
        <img src={statusIcons[status]} alt={status} style={{ width: 16, height: 16 }} />
        <Typography sx={{ fontSize: '13px', fontFamily: 'Poppins' }}>
          {getLocalizedStatus(status)}
        </Typography>
      </Box>
    </MenuItem>
  ))}
</Menu>

    </>
  );
};

export default StatusDropdown;




